// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"index_mainContainer__AWmYf","content":"index_content__sRq9J"};